import type { GetItem } from "@mnk/shared/models/item";
import type { Office } from "@mnk/shared/models/office";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React from "react";
import { Link } from "react-router-dom";
interface Props {
  office: Office;
  pathItems: GetItem[];
}

export const BreadCrumb = ({ office, pathItems }: Props) => {
  return (
    <div className="flex items-center gap-2 my-4">
      <Link to="/">事業所一覧</Link>
      <ChevronRightIcon />
      <Link to={`/offices/${office.id}`}>{office.name}</Link>
      {pathItems.map((item) => (
        <React.Fragment key={item.id}>
          <ChevronRightIcon />
          <Link to={`/folders/${item.id}`}>{item.name}</Link>
        </React.Fragment>
      ))}
    </div>
  );
};
